import React, { useId } from "react";

interface SwitchProps {
  checked: boolean;
  onChange: (checked: boolean) => void;
}

const Switch: React.FC<SwitchProps> = ({ checked, onChange }) => {
  // Unique id per instance — duplicate id/htmlFor breaks multi-switch UIs (wrong row toggles).
  const reactId = useId();
  const inputId = `gf-switch-${reactId.replace(/:/g, "")}`;

  return (
    <label
      htmlFor={inputId}
      className="relative inline-block w-11 h-6 cursor-pointer"
    >
      <input
        type="checkbox"
        id={inputId}
        className="peer sr-only"
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <span className="absolute inset-0 bg-gray-200 rounded-full transition-colors duration-200 ease-in-out peer-checked:bg-[var(--app-primary)] dark:bg-gray-200 dark:peer-checked:bg-[var(--app-primary)] peer-disabled:opacity-50 peer-disabled:pointer-events-none"></span>

      <span className="absolute top-1/2 start-1 -translate-y-1/2 size-4 bg-white rounded-full shadow-xs transition-transform duration-200 ease-in-out peer-checked:translate-x-[120%] dark:peer-checked:bg-white"></span>
    </label>
  );
};

export default Switch;
